const primaryMain = '#8B2346';
const primaryMainOpacity = 'rgba(139, 35, 70, 0.9)';
const secondaryMain = '#FFD200';
const secondaryMainOpacity = 'rgba(255, 210, 0, 0.5)';
const secondaryLight = '#F26329';
const tertiaryMain = '#000000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
